export default "__VITE_ASSET__K$q1F_fi__"